import { Injectable } from '@angular/core';
import {Mapper} from '../../../../core/abstracts/mapper.abstract';
import {VehicleAnnotationRequest} from '../model/vehicle-annotation-request.model';

@Injectable({providedIn: 'root'})
export class VehicleAnnotationRequestMapper extends Mapper<string, VehicleAnnotationRequest> {
  override map(source: string): VehicleAnnotationRequest {
    return new VehicleAnnotationRequest(source);
  }
}
